import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

interface SkipLink {
  href: string;
  label: string;
}

@Component({
  selector: 'app-skip-links',
  standalone: true,
  imports: [],
  templateUrl: './skip-links.component.html',
  styleUrl: './skip-links.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkipLinksComponent {
  private readonly document = inject(DOCUMENT);
  skipLinks: SkipLink[] = [
    { href: '#main-navigation', label: 'Skip to navigation' },
    { href: '#main-content', label: 'Skip to main content' },
    { href: '#global-search', label: 'Skip to search' },
    { href: '#footer', label: 'Skip to footer' }
  ];

  focusElement(event: Event, selector: string): void {
    event.preventDefault();
    // GAP-FE-C014: legitimate a11y skip-link — targets app-shell landmarks
    // (#main-content, #main-navigation, #footer, …) that live outside this
    // component, so ViewChild cannot reach them. Injected DOCUMENT is SSR-safe.
    const element = this.document.querySelector(selector) as HTMLElement;
    if (element) {
      element.focus();
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}